import axios from "axios";

// const API_BASE_URL = "http://localhost:8081/api/v1";
// const API_BASE_URL = "https://6492-157-119-203-125.ngrok-free.app/api/v1";
// const API_BASE_URL = "https://ecommerce-451118.df.r.appspot.com/api/v1";
 const API_BASE_URL = "https://ecommerce-ni11.onrender.com/api/v1";



const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
    headers: { "Content-Type": "application/json" },
    withCredentials: true, // This allows cookies to be sent with requests
});

export default axiosInstance;


